import React, { Component } from 'react'
import styles from './style.css'
import FontIcon from '../../../Components/Atom/FontIcon'
import { Row, Col } from '../../../../SPRINTA/atoms/Grid'

export default class Card extends Component {

    render() {
        return (
            <div
                className={`${styles.cardWrapper} ${this.props.active ? styles.active : ''}`}
                onClick={() => this.props.handleClick()}
                >
                <div className={`${styles.card}`}>
                    <Row>
                        <Col size="2 12" text='center'>
                            <div className={styles.icon}>
                                <FontIcon name={this.props.icon} size={50} />
                            </div>
                        </Col>
                        <Col size="10 12" text='left center'>
                            <div className={styles.title}>
                                <span className={styles.emph}>{this.props.title}</span>
                            </div>
                        </Col>
                        <Col display="none block" text='center'>
                            <div className={styles.description}>
                                {this.props.description}
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/App/Components/Atom/Card/index.js